import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Which plan week the app is looking at: "current" (default) or "next" — sent as ?week=next on every call.
export const planWeek = { value: "current" };

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sorted_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (planWeek.value === "next") config.params = { ...(config.params || {}), week: "next" };
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
